// src/com/map/MapDialog.js
import React, { useEffect, useState } from 'react';
// import { Box } from '@mui/system';
import { Dialog, IconButton, DialogContent } from '@mui/material';
import { AppStyle } from '../../value/AppConst';
import CloseIcon from '@mui/icons-material/Close';
import { useReactiveVar } from '@apollo/client';
import { mapRequestRepo } from '../../value/AppModel';
import VehMapBox from './VehMapBox';

const MapHeaderHeight = 120;

/* ******************************************

    const onClickShowTruckOnMap = () => {
        // set mapRequestRepo data
        const mapData = {
            job: MapValue.Job.ShowTruck,
            info: {
                vehInfoSeq:vehicleSelected.vehInfoSeq,
                vehPlates: vehicleSelected.vehPlates,
                driverName: vehicleSelected.driverName,
                gpsTime: vehicleSelected.gpsTime,
                lat: vehicleSelected.lat,
                lon: vehicleSelected.lon,
                location: vehicleSelected.location,
                posSys: vehicleSelected.posSys,
                direction: vehicleSelected.direction,
                speed: vehicleSelected.speed,
            }
        };
        mapRequestRepo({data: mapData});
    };
****************************************** */
/**
 * 지도에 차량 표시하기 위한 Dialog
 */
export default function MapDialog({
    open,
    onClose,
}) {
    const mapRequestData = useReactiveVar(mapRequestRepo);
    const [mapJob, setMapJob] = useState(null);
    const [mapData, setMapData] = useState({});

    useEffect(() => {
        if(open && mapRequestData && mapRequestData.data && mapRequestData.data.info) {
            setMapJob(mapRequestData.data.job);
            setMapData({...mapRequestData.data.info});
        }
    }, [mapRequestData, open]);

    const wh = window.innerHeight;
    const mapHeight = wh - MapHeaderHeight;

    return(
        <Dialog
            fullScreen
            open={open}
            onClose={onClose}
        >
            <DialogContent style={{display:'flex', padding: 0,}}>
                <div style={{width:1}}></div>
                <div style={{flexGrow:1, display:'flex', flexDirection:'column', padding: 0,}}>
                    <div style={{
                            display:'flex', alignItems:'center', backgroundColor: AppStyle.NaverGreen,
                            color: 'white',
                            height: MapHeaderHeight,
                        }}
                    >
                        <div style={{flexGrow:1, padding: '0.7rem', fontWeight:'bold'}}>
                            <div style={{fontSize: '1.1rem', paddingBottom: '0.7rem'}}>
                                {mapData.vehPlates}, {mapData.driverName || '[운전자]'}
                            </div>
                            <div style={{fontSize: '0.9rem' }}>
                                <div style={{padding: '0.2rem'}}>
                                    {mapData.location}
                                </div>
                                <div style={{padding: '0.2rem'}}>
                                    보고시각: {mapData.gpsTime}
                                </div>
                            </div>
                        </div>
                        <IconButton onClick={onClose}>
                            <CloseIcon style={{color: 'white'}}/>
                        </IconButton>
                    </div>
                    <VehMapBox
                        mapData={mapData}
                        height={mapHeight}
                    />
                </div>
                <div style={{width:1}}></div>
            </DialogContent>
        </Dialog>
    );
}